module.exports = __webpack_public_path__ + "static/img/day1.4cf0f9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day1.jpg
// module id = 90GQ
// module chunks = 0